import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "transcript-block__avatar" }
const _hoisted_2 = { class: "transcript-block__text" }
const _hoisted_3 = { class: "transcript-block__author" }
const _hoisted_4 = {
  ref: "chunksWrapper",
  class: "transcript-block__chunks"
}
const _hoisted_5 = ["lang"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")!

  return (_openBlock(), _createElementBlock("div", {
    class: "transcript-block",
    style: _normalizeStyle($options.transcriptBlockStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AvatarWrapper, {
        id: $options.actorId,
        token: $props.token,
        name: $options.actorDisplayName,
        source: $options.actorType,
        size: $data.AVATAR.SIZE.SMALL,
        "disable-menu": true
      }, null, 8, ["id", "token", "name", "source", "size"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString($options.actorInfo), 1),
      _createElementVNode("p", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.chunksWithSeparator, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            ref_for: true,
            ref: "chunks",
            key: index,
            lang: item.languageId
          }, _toDisplayString(item.message), 9, _hoisted_5))
        }), 128))
      ], 512)
    ])
  ], 4))
}